export enum RelationProductType {
  COORDI = 'COORDI',
  TOGETHER = 'TOGETHER',
}
